<div *ngIf="blogData" style="background-color: #F7F9FC">
  <div class="container ">
    <div class="row justify-content-center" style="margin-left: 0px !important">
      <div class="col-md-8  blog" style="border-radius: 18px;">
        <div style="display: flex; flex-direction: row; justify-content: space-between">
          <h1 class="font-26 font-weight-bold mb-3 uppercase" style="padding-top: 11px;">
            {{ blogData?.title }}
          </h1>
          
          <div style="display: flex; flex-direction: row;justify-content: center;  margin-bottom:16px">
            <div matRipple style="background-color: #F7F9FC; margin-right: 12px; width: 50px; height:50px; display: flex; justify-content: center; align-items: center; border-radius: 26px;">
              <a
                [inlineSVG]="'assets/icons/facebookBlog.svg'"
                class="hover-icon"
                style="width: 24px;  "
                shareButton="facebook"
                url="{{ this.baseUrl }}/blog-new/{{ getBlotTitle() }}/{{
                  this.blogId
                }}"
              ></a>
            </div>
            <div matRipple style="background-color: #F7F9FC;  width: 50px; height:50px; display: flex; justify-content: center; align-items: center; border-radius: 26px;" (click)="copyBlogUrl()">
              <a [inlineSVG]="'assets/icons/linkBlog.svg'" style="width: 24px;" class="hover-icon"></a>
            </div>
          </div>
       

        </div>
        <!-- <p class="time text-center mb-5">22 ოქტომბერი, 2019</p> -->
        <img
          loading="lazy"
          alt="{{ blogData?.title }}"
          class="lazyload blog-image w-100 mb-5"
          data-src="{{ url }}/blog/image/{{ blogData?.img }}"
        />
        <!-- <div class="divider mb-5 mt-1"></div> -->
        <!-- <div class="social-share">
          <div class="fb-share-wrapper" matRipple>
            <a
              [inlineSVG]="'assets/icons/facebookBlog.svg'"
              class="svg-12 fb"
              shareButton="facebook"
              url="{{ this.baseUrl }}/blog-new/{{ getBlotTitle() }}/{{
                this.blogId
              }}"
            ></a>
          </div>
          <div class="fb-share-wrapper copy" matRipple (click)="copyBlogUrl()">
            <a [inlineSVG]="'assets/img/link.svg'" class="svg-12"></a>
          </div>
        </div> -->
        <!--      <div [innerHTML]="blogData?.fullText | sanitize" id="detail-blog" class="mb-5 font-16 text-justify blog-description"></div>-->
        <div
          [innerHTML]="blogData?.fullText | keepHtml"
          style="overflow: hidden"
          class="mb-5 full-description"
        ></div>
      </div>

      <div
        class="col-md-4 mt-5 mb-5 popular-doctors"
        style="position: relative; margin-bottom: 2rem !important; padding-left: 24px;"
        [ngStyle]="isMobile ? {'padding-left': '0px', 'padding-right': '0px'} : { }"
        [ngClass]="{'margin-swipper' : isMobile}"
        *ngIf="doctorsList?.length"
      > 
      <div class="move-down-element">
        <div
          class="section-header d-flex align-items-center justify-content-end swipper-cont"
          style="margin-top: -18px; border-radius: 18px !important;"
        > 
          <p style="color: #7C8594; padding-right: 30px; padding-top:14px" >ხელმისაწვდომი ექიმები</p>
          <div class="d-flex align-items-center">
            <!--          <div class='pagination'></div>-->
            <button class="new-prev" style="margin-right: 0px !important" mat-icon-button>
              <mat-icon>west</mat-icon>
            </button>
            <button class="new-next" mat-icon-button>
              <mat-icon>east</mat-icon>
            </button>
          </div>
        </div>
        <swiper
          [breakpoints]="popularDoctorsConfig.breakpoints"
          [lazy]="true"
          [navigation]="popularDoctorsNav"
          [pagination]="popularDoctorsPagination"
          [preloadImages]="false"
          [spaceBetween]="24"
          class="swiper-container doctors "
        >
          <div class="swiper-wrapper">
            <ng-template *ngFor="let doctor of doctorsList" swiperSlide>
              <div
                class="popular-doctor__container "
                
              >
                <div style="display: flex; flex-direction: row; margin-bottom: -40px;">
                  <div
                    class="position-relative popular-doctor__container--img-section text-center"
                    style="margin-top: 24px"
                  >
                    <img
                      alt=""
                      class="swiper-lazy"
                      style="margin-left: 24px;"
                      data-src="{{
                        baseUrl +
                          '/web/api/files/profile_pic/' +
                          doctor.userId +
                          '?size=s'
                      }}"
                      loading="lazy"
                    />

                    <!-- <div class="doctor-rating">
                      <mat-icon svgIcon="star"></mat-icon>
                      <span>{{ doctor?.raitingavg }}</span>
                    </div> -->
                  </div>
                  <div class="doctor-info__container">
                    <div class="doctor-info__name">
                      <span class="doctor-name">{{ doctor.fullName }}</span>
                    </div>
                    <div class="doctor-info__specialty">
                      {{ doctor.specialties[0].specialtyName }}
                    </div>
                    <div
                      class="doctor-info__specialty text-danger font-weight-bold"
                    >
                      {{ doctor?.clinic?.name }}
                    </div>
                    <!-- <div class="doctor-info__actions">
                      <div class="doctor-info__actions-services">
                        <div class="doctor-info__service">
                          <div
                            [inlineSVG]="
                              'assets/card-icons/new/home_visit_card-only-home.svg'
                            "
                            class="svg-18"
                          ></div>
                        </div>
                        <div class="doctor-info__service">
                          <div
                            [inlineSVG]="
                              'assets/card-icons/new/video_call_card-only-video.svg'
                            "
                            class="svg-21"
                          ></div>
                        </div>
                        <div class="doctor-info__service">
                          <div
                            [inlineSVG]="
                              'assets/card-icons/new/audio-call-cart-only-audio.svg'
                            "
                            class="svg-18 fill"
                          ></div>
                        </div>
                      </div>
                      <button matRipple>
                        <mat-icon> keyboard_arrow_right </mat-icon>
                      </button>
                    </div> -->
                  </div>
                </div>
                <button
                matRipple
                (click)="navigateToDoctorProfile(doctor)"
                class="btn-txt" 
                style="margin-bottom: 24px; height: 40px !important; width: 90%; margin-left: 5%">დაჯავშნე ონლაინ კონსულტაცია</button>
              </div>
            </ng-template>
          </div>
        </swiper>
      </div>
      </div>
    </div>



    <div class="news" style="margin-top: 0px !important;">
      <div
        class="section-header d-flex align-items-center mb-3 justify-content-between"
        style="margin-top: 28px"
      >
        <h3 class="section-title" style="font-size: 24px;">{{ ("redmeds-services" | translate) | uppercase }}</h3>
      </div>
      <div class="cards-wrapper">
      <div class="card-wrapper"
            (click)="onInsuranceProviderDoctorBubbleClick()"
          >
            <img style="width: 52px; height: 58px" src="assets/card-icons/new/tbc-logo.svg" alt="">
            <div>
              <h6 class="card-text">
                {{ "tbc-insurance-doctors" | translate }}
              </h6>
            <small class="card-text-bottom">{{
              "video-consultation" | translate
            }}</small>
            </div>
            <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">
          </div>

        <div class="card-wrapper"
        [queryParams]="{ online: true }"
        routerLink="/search-step"
        >
          <img style="width: 52px; height: 58px" src="assets/card-icons/new/video_call_card.svg" alt="">
          <div>
          <h6 class="card-text">
            {{ "doctor-online-consultation" | translate }}
          </h6>
          <small class="card-text-bottom">{{ "300-specialists" | translate | slice:0:25}}</small>
        </div>
        <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

      </div>
          
      <div
      class="card-wrapper"
      (click)="goToClinicWeb()"
      >
        <img style="width: 52px; height: 58px" src="assets/card-icons/new/clinic-visit-card.svg" alt="">
        <div>
        <h6 class="card-text">
          {{ "book-a-visit-to-the-clinic" | translate }}
        </h6>
        <small class="card-text-bottom">{{
          "30-clinics-300-doctors" | translate | slice:0:25
        }}</small>
        </div>
        <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

      </div>

      <div
        class="card-wrapper"
        [queryParams]="{ serviceType: 2 }"
        routerLink="/search-step"
      >
        <img style="width: 52px; height: 58px" src="assets/card-icons/new/home_visit_card.svg" alt="">
        <div>
          <h6 class="card-text">
            {{ "doctor-at-home" | translate }}
          </h6>
        <small class="card-text-bottom">{{ "pediatrician-therapist" | translate | slice:0:25}}</small>
      </div>
      <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">
  
      </div>

      <div
      class="card-wrapper"
      (click)="goToNurseAtHome()"
      >
        <div class="nurse-at-home-new-wrapper">
          <img style="width: 52px; height: 58px" src="assets/card-icons/new/Home_Visit_Nurse.png" alt="">
          <p>{{ 'new' | translate | uppercase}}</p>
        </div>
        <div>
          <h6 class="card-text">
            {{ "nurse-at-home" | translate }}
          </h6>
          <small class="card-text-bottom">{{ "book-nurse-at-home" | translate | slice:0:25}}</small>
        </div>
        <p style="display: none;" class="new-icon">{{ 'new' | translate | uppercase}} ></p>

      </div>

      <div
        class="card-wrapper"
        (click)="goToClinicWeb('lab')"
      >
        <img style="width: 52px; height: 58px" src="assets/card-icons/new/laboratory_card.svg" alt="">
        <div>
          <h6 class="card-text">
            {{ "laboratory-tests" | translate }}
          </h6>
          <small class="card-text-bottom">{{ "house-or-lab" | translate | slice:0:25}}</small>
        </div>
      <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

      </div>

      <div
        class="card-wrapper"
        [queryParams]="{ serviceType: 1, foreign: true }"
        routerLink="/search"
      >
        <img style="width: 52px; height: 58px" src="assets/card-icons/new/doctor_card.svg" alt="">
        <div>
          <h6 class="card-text">
            {{ "doctors-abroad" | translate }}
          </h6>
          <small class="card-text-bottom">{{
          "secondary-opinion" | translate | slice:0:25
        }}</small>
        </div>
        <img class="nextIcon" src="../../../assets/icons/Stroke-6.png" alt="" style="display: none;">

      </div>

      </div>            
      
    </div>






    <div class="blog" *ngIf="blogDataAvailable && selectedLanguage === 'ka'">
      <div
        class="section-header d-flex align-items-center justify-content-between"
        style="padding-top: 30  px"
      >
        <h3 class="section-title" style="font-size: 24px; margin-left: 20px; padding-top: 3px">{{ "blog-other" | translate | uppercase}}</h3>
        <!-- <h1 class="blog-num" style="margin-left: 20px"> {{ "blog-num" | translate }} {{" " + newBlogs.length}} {{"blog-page" | translate}}</h1> -->
        <div class="d-flex align-items-center">
          <a class="seeAll" routerLink="/blog-list">{{
            "see-all" | translate
          }}</a>
          <div class="pagination"></div>
          <button class="new-prev" mat-icon-button>
            <mat-icon>west</mat-icon>
          </button>
          <button class="new-next" mat-icon-button>
            <mat-icon>east</mat-icon>
          </button>
        </div>
      </div>
      <swiper
        [breakpoints]="popularBlogConfig.breakpoints"
        [lazy]="true"
        [navigation]="popularBlogNav"
        [pagination]="popularBlogPagination"
        [preloadImages]="false"
        [spaceBetween]="24"
        class="swiper-container blog"
      >
        <ng-template *ngFor="let blog of newBlogs" swiperSlide>
          <app-blog-quick-view
            [blog]="blog"
            [showEllipsis]="true"
          ></app-blog-quick-view>
        </ng-template>
        <ng-template swiperSlide>
          <app-blog-quick-view
            [empty]="true"
            [showEllipsis]="true"
          ></app-blog-quick-view>
        </ng-template>
      </swiper>
      <a *ngIf="isMobile" class="seeAllBlogsMobile" routerLink="/blog-list">{{
        "see-all" | translate
      }}</a>
    </div>

    <div class="app-block">
      <div class="row">
        <div
          class="col-lg-7 d-none d-lg-flex align-items-end"
          style="position: relative; bottom: -20px"
        >
          <img
            style="width: 342px"
            alt=""
            class="lazyload position-absolute"
            data-src="/assets/img/wooden-hand-iPhone-12-pro.png"
            loading="lazy"
          />
        </div>
        <div
          class="col-lg-5 d-flex align-items-center  justify-content-lg-start justify-content-center"
          [ngClass]="isDesktop? 'py-5' : ''"
        >
          <div>
            <h2 *ngIf="isDesktop"
              class="download-redmed-app-text text-center text-lg-left"
            >
              {{ "download-the-redmed-app" | translate | uppercase }}
            </h2>
            <h2 *ngIf="!isDesktop"
              class="download-redmed-app-text text-center text-lg-left"
              style="font-size: 18px; margin-bottom: 12px; margin-top:12px"
            >
              {{ "download-the-redmed-app" | translate | uppercase }}
            </h2>
            <div *ngIf="!isDesktop" style=" display: flex; justify-content: center;">
              <h2 
                class="download-redmed-app-text text-center text-lg-left"
                style="font-size: 14px; font-weight: 500; line-height: 30px; "
              >
                {{ "download-the-redmed-app-available" | translate }}
              </h2>
            </div>
            <h1   *ngIf="isDesktop" class="ttxt">{{"download-the-redmed-qr" | translate}}</h1>
            <img  *ngIf="isDesktop" data-src="/assets/banner-images/qr.png" class="lazyload mr-3" style="width: 108px; border-radius: 8px;" alt="qr">
            <div *ngIf="!isDesktop"
              class="d-flex stores justify-content-center justify-content-lg-start"
            >
            <div style="display: flex; flex-direction: column; width:100%">
              <div style="background-color: white; border-radius: 20px; display: flex; justify-content: center; margin-bottom: 16px">
                <a
                  href="https://apps.apple.com/us/app/redmed/id1483844703"
                  target="_blank"
                  style="width: 90%; display: flex; justify-content: center;"
                >
                  <img
                    alt=""
                    class="lazyload mr-3"
                    data-src="/assets/photos/appstore-new.png"
                    loading="lazy"
                  />
                </a>
              </div>
              <div style="background-color: white; border-radius: 20px; display: flex; justify-content: center; ">
                <a
                  href="https://play.google.com/store/apps/details?id=ge.redmed.patient"
                  target="_blank"
                >
                  <img
                    alt=""
                    class="lazyload"
                    data-src="/assets/photos/playstore-new.png"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    
   
  
  </div>
</div>
